import { render, staticRenderFns } from "./BarChartComponent.vue?vue&type=template&id=8e4f7554&scoped=true"
import script from "./BarChartComponent.vue?vue&type=script&lang=js"
export * from "./BarChartComponent.vue?vue&type=script&lang=js"
import style0 from "./BarChartComponent.vue?vue&type=style&index=0&id=8e4f7554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4f7554",
  null
  
)

export default component.exports